$(document).scroll(function() {
  if ($(window).innerHeight() < $(".toggle_sticky_position_js").outerHeight()) {
    $(".toggle_sticky_position_js").removeClass("sticky-top")
  } else {
    $(".toggle_sticky_position_js").addClass("sticky-top")
  }
});
